import { THelperState, THelperAction } from "./helper.state";
import { SearchActions } from "~/types/actions.enum";

// ✅ Search helper utils reducer logic
export const helperReducer = (state: THelperState, action: THelperAction): THelperState => {
    switch (action.type) {
        case SearchActions.SET_IS_MODAL_OPEN:
            return { ...state, isModalOpen: action.payload };

        case SearchActions.SET_IS_LOADING:
            return { ...state, isLoading: action.payload, isError: false };

        case SearchActions.SET_IS_ERROR:
            return { ...state, isLoading: false, isError: action.payload };

        case SearchActions.SET_SEARCH_VIEW_MODE:
            return { ...state, viewMode: action.payload };

        case SearchActions.SET_TOPIC_KEYWORD:
            return { ...state, keyword: action.payload };

        case SearchActions.SET_IS_INITIALIZED:
            return { ...state, isAppInitialized: action.payload };

        default:
            return state;
    }
};
